import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { PRIMARY_COLOR, SECOND_COLOR } from "utils/const";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import neuronaGreen from "../../../images/neuron-3.png";

export const HubContainer = styled.div`
  // width: 100%;
  height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 8rem;
  justify-content: flex-start;

  background-color: #fafafa;
  border: 1px solid #bebebe;


`;

export const ContainerIntro = styled.div`
  padding: 2rem 1rem;
  display: grid;
  grid-template-columns: 0.25fr 3fr 1fr;
  margin-top: 20px;
  margin-right: 70px;
  width: 100%;
`;

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const LogoSmall = styled.img`
  // background-image: url(${neuronaGreen});
  // background-size: cover;
  width: 50px;
  height: 50px;
  // margin-right: 10px;
  // justify-self: center;
`;

export const LogoBig = styled.div`
  background-image: url("https://icons-greendragon.s3.us-east-2.amazonaws.com/other/neurona-gris.png");
  background-size: cover;
  width: 120px;
  height: 120px;
  margin-bottom: 10px;
  justify-self: center;
  

  grid-column: 3;

  @media (max-width: 768px) {
    width: 90px;
    height: 90px;
    display: none;
  }
`;

export const LastConteiner = styled.div`
display: grid;
grid-template-columns: 0.25fr 3fr 1fr;
// border: solid 2px brown;

@media (max-width: 1190px) {
  display: flex;
  padding: 1rem 0;
  justify-content: flex-end;
}
`

export const UserH2Flex = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 1rem;

  font-size: 17px;
  color: #010606;
  // border: solid 2px orange;

  b {
    color: ${PRIMARY_COLOR};
  }

  grid-column: 3;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const NavInfo = styled.div`
  margin-top: 13%;
  margin-left: 15%;

  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;

export const Nav = styled.nav`
  background-color: ${PRIMARY_COLOR};
  height: 80px;
  /* margin-top: -80px; */
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 3px 6px #00000066;
  font-size: 1.4rem;
  position: sticky;
  top: 0;
  z-index: 10;
  width: ${(props) => (props.tipo ? "90%" : "100%")};
  margin-left: ${(props) => (props.tipo ? "10%" : "0%")};

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  width: 89%;
  // border: solid 2px red;
`;

export const ArrowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: auto;
  /* background-color: #ffffff; */
  /* box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2); */
  cursor: pointer;
`;

export const LeftArrow = styled(ArrowLeftIcon)`
  color: ${SECOND_COLOR};
  margin: 10px;
`;

export const RightArrow = styled(ArrowRightIcon)`
  color: ${SECOND_COLOR};
  margin: 10px;
`;

export const HubWrapper = styled.div`
  /* width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));
  grid-auto-rows: 30rem;
  align-items: center;
  gap: 3rem; */

  padding: 10px 0;
  display: flex;
  overflow-x: hidden;
  scroll-behavior: smooth;
  scroll-snap-type: x proximity;
  // border: solid 2px violet;
  width: 100%;

`;

export const HubCard = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  min-width: 295px;
  margin: 0 20px;
  padding: 30px;
  transition: all 0.2s ease-in-out;
  box-shadow: 5px 3px 6px #00000066;
  width: 100%;
  // border: solid 2px green;


  &:hover {
    transform: scale(1.05);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    margin-right: 15px;
    margin-left: 7px;
  }

`;

export const HubIcon = styled.img`
  height: 160px;
  width: 160px;
  margin-bottom: 10px;
`;

export const HubH1 = styled.h1`
  font-size: 3rem;
  font-weight: 600;
  color: ${PRIMARY_COLOR};
  margin-bottom: 20px;
  text-align: justify;

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const HubH2 = styled.h2`
  font-size: 1.6rem;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const HubD = styled.p`
font-size: 18px;
text-align: justify;
`;

export const HubP = styled.p`
  font-size: 18px;
  text-align: center;
`;

export const UserInfoReport = styled.div`
  display: grid;
  gap: 0.5rem;
  grid-auto-rows: 3rem;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  border: 2px solid #ececec;
  border-radius: 15px;
  padding: 1.2rem 0;
  margin-top: 3rem;
`;

export const UserContainer = styled.div`
  // justify-content: center;
  border: 2px solid pink;
  height: 800px;
  padding-left: 20px;
  padding-right: 70px;
  margin-top: 70px;
  /* padding-top: 40px; */
  /* margin-left: 80px; */
  /* margin-right: 80px; */
`;

export const UserH1 = styled.h1`
  margin-bottom: 2px;
  font-size: 3rem;
  font-weight: 500;
  color: #010606;
`;

export const UserH2 = styled.text`
  font-size: 2.2rem;
  color: #010606;
  margin-bottom: 15px;
`;

export const ReportItem = styled.div`
  font-size: 2rem;
  padding: 3px;
  background-color: #f9f9f9;
  /* padding-right: 50px; */
  border-radius: 0;
  align-self: center;
  justify-self: center;
`;

export const NavbarLogoR = styled(LinkR)`
  color: #fff;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-right: 24px;
  font-weight: bold;
  text-decoration: none;
`;
